// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5f908bef","809":"82ddc859","879":"a4f84f84"}[chunkId] + ".chunk.js";
};